<div class="page-header">
  <div class="d-flex align-items-center justify-content-between">
    <div *ngIf="backToList">
      <a [routerLink]="backToList.path">
        <span class="h4 mr-2">
          <jhi-bary-icon icon="arrow-left" [faDirective]="FAS" class="text-dark"></jhi-bary-icon>
        </span>
      </a>
    </div>
    <div>
      <h2 class="mb-0 ml-3">{{ title }}</h2>
    </div>
    <div>
      <jhi-bary-button *ngIf="button" [label]="button.label" [outline]="true" size="sm" (clickEvent)="buttonClickEvent.emit()" color="primary"></jhi-bary-button>
    </div>
  </div>
</div>
